import React from "react";

const Index = () => {
  const collaborationLogoImages = [
    "/images/collaboration/nickelfox.webp",
    "/images/collaboration/epleyer.webp",
    "/images/collaboration/affordabledebtconsolidation.webp",
    "/images/collaboration/debtredemption.webp",
    "/images/builtflat.svg",
    "/images/doofy.svg",
    "/images/litheum.svg",
    "/images/nothing-design-studio.png",
  ];

  return (
    <div className="bg-white py-5">
      <div className="container my-2 my-md-5">
        <div className="pb-5 text-left small-container">
          <h2 className="fs-1 mb-3 fw-bold">Proud Collaborations</h2>
          <p className="text-muted fs-4 col-lg-8 col-md-10">
            Over the years, I've had the privilege of working alongside some of
            the industry's most esteemed companies. Here's a glimpse:
          </p>
        </div>

        <div className="mx-auto row">
          {collaborationLogoImages.map((imagePath, i) => (
            <div
              className="col-lg-4 col-xl-3 col-6 client-logo d-flex justify-content-center align-items-center"
              key={i}
            >
              <img
                className="img-fluid rounded"
                alt="alternative"
                src={imagePath}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Index;
